import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Typography, Grid, FormControlLabel, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { showToast } from '../../../Toaster/Toaster';
import { useMutation, useQueryClient } from 'react-query';
import { UpdateCompanyBusinessLicenseMutation } from '../../new-member-applications/IndexFile/UpdateMutation/CompanyUpdateMutation';
import { API_ENDPOINTS } from '../../../rest/utils/api-endpoints';
import { IViewCompanyBusinessLicenseInfo } from '../../../rest/types';
import MultipleAndSingleImgValidateWithPreview from '../../../Components/FileValidation/MultipleAndSingleImgValidateWithPreview';

interface IProps {
  memberId: number;
  companyBusinessLicense: IViewCompanyBusinessLicenseInfo;
}

const CompanyBusinessLicense = ({ companyBusinessLicense }: IProps) => {
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();
  const [businessLicense, setBusinessLicense] = useState<any>();
  const queryClient = useQueryClient();

  console.log(businessLicense, '----------');
  const mutation = useMutation({
    mutationFn: (data: any) => {
      return UpdateCompanyBusinessLicenseMutation(data);
    },
    onSuccess: () => {
      showToast('successfully updated', 'success');
    },
    onError: (error: any) => {
      showToast(`${error.response.data.message}`, 'error');
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [API_ENDPOINTS.OWNER_BUSINESS_LICENSE],
      });
    },
  });

  const onSubmit = async () => {
    const inputsData: any = { ...businessLicense };
    const formData = new FormData();

    if (businessLicense && Object?.values(businessLicense)?.length > 0) {
      Object?.keys(inputsData)?.forEach((key) => {
        if (typeof inputsData[key] === 'object') {
          if (inputsData[key][0] && inputsData[key]) {
            formData.append(key, inputsData[key][0]);
          }
        } else {
          formData.append(key, inputsData[key]);
        }
      });
      mutation.mutate(formData);
    } else {
      showToast('Please change field first', 'error');
    }
  };
  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Update Other business license
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyBusinessLicense
                        ?.hajj_license
                        ? true
                        : false
                    }
                  />
                }
                label='Hajj'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,

                      hajj_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      hajj_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyBusinessLicense
                        ?.umrah_license
                        ? true
                        : false
                    }
                  />
                }
                label='Umrah'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      umrah_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyBusinessLicense
                        ?.recruting_license
                        ? true
                        : false
                    }
                  />
                }
                label='Recruiting'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      recruting_license: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyAssociationMembership
                        ?.baira_membership
                        ? true
                        : false
                    }
                  />
                }
                label='BAIRA'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      baira_membership: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      baira_membership: 0,
                    });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        companyBusinessLicense?.companyAssociationMembership
                          ?.haab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='HAAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        haab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        haab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        companyBusinessLicense?.companyAssociationMembership
                          ?.iata_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='IATA'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        iata_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        iata_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        companyBusinessLicense?.companyAssociationMembership
                          ?.toab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='TOAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        toab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        toab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ pl: { xs: 12, md: 0 } }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={
                        companyBusinessLicense?.companyAssociationMembership
                          ?.tdab_membership
                          ? true
                          : false
                      }
                    />
                  }
                  label='TDAB'
                  onClick={(e: any) => {
                    if (e.target.checked) {
                      setBusinessLicense({
                        ...businessLicense,
                        tdab_membership: 1,
                      });
                    } else {
                      setBusinessLicense({
                        ...businessLicense,
                        tdab_membership: 0,
                      });
                    }
                  }}
                />
              </Box>
            </Grid>

            {/* Add more items here as needed */}
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant='h6' gutterBottom>
            Update Involved in tourism activities
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 15,
              pl: { xs: 7, md: 0 },
              // justifyContent: 'space-evenly',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyBusinessLicense?.inbound
                        ? true
                        : false
                    }
                  />
                }
                label=' Inbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      inbound: 0,
                    });
                  }
                }}
              />
            </Box>
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={
                      companyBusinessLicense?.companyBusinessLicense?.outbound
                        ? true
                        : false
                    }
                  />
                }
                label='Outbound'
                onClick={(e: any) => {
                  if (e.target.checked) {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 1,
                    });
                  } else {
                    setBusinessLicense({
                      ...businessLicense,
                      outbound: 0,
                    });
                  }
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      {/*---------------------- file------------------------ */}
      <Grid container spacing={2}>
        {/* Hajj License */}
        {companyBusinessLicense?.companyBusinessLicense?.hajj_license ||
        businessLicense?.hajj_license ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Member organization Hajj license ( max size 5mb )'
                fieldName='hajj_license_file'
                imgSerUrl={[
                  companyBusinessLicense?.companyBusinessLicense
                    ?.hajj_license_file,
                ]}
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    hajj_license_file: e,
                  }))
                }
                mode='single'
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* Umrah License */}
        {companyBusinessLicense?.companyBusinessLicense?.umrah_license ||
        businessLicense?.umrah_license ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                hideCustomLabel
                label='Member organization Umrah license ( max size 5mb )'
                fieldName='umrah_license_file'
                imgSerUrl={[
                  companyBusinessLicense?.companyBusinessLicense
                    ?.umrah_license_file,
                ]}
                mode='single'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    umrah_license_file: e,
                  }))
                }
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* Recruiting License */}
        {companyBusinessLicense?.companyBusinessLicense?.recruting_license ||
        businessLicense?.recruting_license ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Member organization Recruiting license ( max size 5mb )'
                fieldName='recruting_license_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    recruting_license_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  companyBusinessLicense?.companyBusinessLicense
                    ?.recruting_license_file,
                ]}
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* BAIRA Membership */}
        {companyBusinessLicense?.companyAssociationMembership
          ?.baira_membership || businessLicense?.baira_membership ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association BAIRA document ( max size 5mb )'
                fieldName='baira_membership_file'
                imgSerUrl={[
                  companyBusinessLicense?.companyAssociationMembership
                    ?.baira_membership_file,
                ]}
                mode='single'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    baira_membership_file: e,
                  }))
                }
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* HAAB Membership */}
        {companyBusinessLicense?.companyAssociationMembership
          ?.haab_membership || businessLicense?.haab_membership ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association HAAB document ( max size 5mb )'
                fieldName='haab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    haab_membership_file: e,
                  }))
                }
                hideCustomLabel
                mode='single'
                imgSerUrl={[
                  companyBusinessLicense?.companyAssociationMembership
                    ?.haab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* IATA Membership */}
        {companyBusinessLicense?.companyAssociationMembership
          ?.iata_membership || businessLicense?.iata_membership ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association IATA document ( max size 5mb )'
                fieldName='iata_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    iata_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  companyBusinessLicense?.companyAssociationMembership
                    ?.iata_membership_file,
                ]}
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* TOAB Membership */}
        {companyBusinessLicense?.companyAssociationMembership
          ?.toab_membership || businessLicense?.toab_membership ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association TOAB document ( max size 5mb )'
                fieldName='toab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    toab_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  companyBusinessLicense?.companyAssociationMembership
                    ?.toab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}

        {/* TDAB Membership */}
        {companyBusinessLicense?.companyAssociationMembership
          ?.tdab_membership || businessLicense?.tdab_membership ? (
          <Grid item xs={12} sm={6} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload association TDAB document ( max size 5mb )'
                fieldName='tdab_membership_file'
                onChange={(e) =>
                  setBusinessLicense((prev: any) => ({
                    ...prev,
                    tdab_membership_file: e,
                  }))
                }
                mode='single'
                imgSerUrl={[
                  companyBusinessLicense?.companyAssociationMembership
                    ?.tdab_membership_file,
                ]}
              />
            </Box>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
      <Box sx={{ pt: 5, textAlign: 'end', mb: 2 }}>
        {mutation.isLoading ? (
          <Button
            disabled
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            Loading..
          </Button>
        ) : (
          <Button
            type='submit'
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            Save
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CompanyBusinessLicense;
